import IconButton from '@mui/material/IconButton';
import { useTheme } from '../../context/ThemeContext';

interface ThemeToggleProps {
  className?: string;
}

export default function ThemeToggle({ className }: ThemeToggleProps) {
  const { resolvedTheme, preference, toggleTheme } = useTheme();

  const isDark = resolvedTheme === 'dark';
  const icon = isDark ? 'light_mode' : 'dark_mode';
  const nextLabel = isDark ? 'Цайвар горим руу шилжих' : 'Харанхуй горим руу шилжих';
  const title =
    preference === 'system'
      ? `${nextLabel} (одоо системийн дагуу). Shift+дарвал системийн дагуу үлдэнэ.`
      : `${nextLabel}. Shift+дарвал системийн дагуу автоматаар.`;

  return (
    <IconButton
      size="small"
      className={className}
      onClick={(e) => toggleTheme(e)}
      aria-label={nextLabel}
      title={title}
      sx={{ color: 'text.secondary', borderRadius: 2 }}
    >
      <span className="material-symbols-outlined" aria-hidden>
        {icon}
      </span>
    </IconButton>
  );
}
